<template>
  <div v-if="threeItem">
    <h2>{{threeItem.name }}</h2>
    <!-- <el-table :data="tableData" :span-method="objectSpanMethod">
      <el-table-column prop="date" label="使用图卡" width="150"></el-table-column>
      <el-table-column label="评量项目" prop="name" width="350"></el-table-column>
      <el-table-column label="构音" width="150" prop="articulation"></el-table-column>
      <el-table-column label="构音" width="150" prop="articulation2"></el-table-column>
      <el-table-column label="声调">
        <el-table-column prop="name" label="阴（第一声）" width="120"></el-table-column>
        <el-table-column prop="name" label="阳（第二声）" width="120"></el-table-column>
        <el-table-column prop="name" label="上（第三声）" width="120"></el-table-column>
        <el-table-column prop="name" label="去（第四声）" width="50"></el-table-column>
      </el-table-column>
      <el-table-column label="构音错误类型">
        <el-table-column prop="name" label="替代" width="40"></el-table-column>
        <el-table-column prop="name" label="省略" width="40"></el-table-column>
        <el-table-column prop="name" label="添加" width="40"></el-table-column>
        <el-table-column prop="name" label="歪曲" width="40"></el-table-column>
        <el-table-column prop="name" label="整体含糊不清" width="40"></el-table-column>
      </el-table-column>
    </el-table>-->

    <div class="topicBox" style="width: 1300px">
      <el-table
        class="elTableTop"
        :data="threeItem.list"
        style="width: 100%"
        :span-method="objectSpanMethod"
        :header-cell-style="handerMethod"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="date" label="使用图卡" width="120"></el-table-column>
        <el-table-column label="评量项目" prop="name" width="150"></el-table-column>

        <el-table-column label="构音" width="100" prop="articulation"></el-table-column>
        <el-table-column label="构音" width="100" prop="articulation2"></el-table-column>

        <el-table-column label="声调">
          <!-- <el-checkbox-group v-model="checkList"> -->
          <el-table-column label="阴（第一声）" width="100">
            <template slot-scope="{row}">
              <!-- <el-checkbox @change=" selectChange ( $event , 1 ) " v-model="row.select1"></el-checkbox> -->
              <el-input type="text" maxlength="3" v-model="row.select1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label=" 阳（第二声）" width="100">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.select2"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="上（第三声）" width="100">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.select3"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="去（第四声）" width="100">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.select4"></el-input>
            </template>
          </el-table-column>
          <!-- </el-checkbox-group> -->
        </el-table-column>
        <el-table-column label="构音错误类型">
          <el-table-column label="替代">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.dysarthria1"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="省略">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.dysarthria2"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="添加">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.dysarthria3"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="歪曲">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.dysarthria4"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="整体含糊不清">
            <template slot-scope="{row}">
              <el-input type="text" maxlength="3" v-model="row.dysarthria5"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <el-table
        class="tableBottom"
        style="width: 100%"
        border
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column label="评  量  结  果" width="270" class="result"></el-table-column>
        <el-table-column width="600">
          <template slot="header">
            <div class="elHeader">
              <div class="box1">
                <div>错误音是哪些音？</div>
                <el-form ref="form" class="form" label-width="10px">
                  <el-form-item>
                    <el-input v-model="threeItem.errSound"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="box1">
                <div>正确音有几个？</div>
                <el-form ref="form" class="form" label-width="10px">
                  <el-form-item>
                    <el-input v-model="threeItem.sound"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div>
              <div>
                错误声调：
                <el-checkbox-group v-model="threeItem.toneErr">
                  <el-checkbox label="阴"></el-checkbox>
                  <el-checkbox label="阳"></el-checkbox>
                  <el-checkbox label="上"></el-checkbox>
                  <el-checkbox label="去"></el-checkbox>
                </el-checkbox-group>
                <div>(可复选)</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            <div>
              <div>构音错误类型（可复选）</div>
              <div>
                <el-checkbox-group v-model="threeItem.dysarthriaErr" class="headerErr">
                  <el-checkbox label="替代音"></el-checkbox>
                  <el-checkbox label="省略音"></el-checkbox>
                  <el-checkbox label="添加音"></el-checkbox>
                  <el-checkbox label="歪曲音"></el-checkbox>
                  <el-checkbox label="整体含糊不清"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-button type="success" @click="selectChange">成功按钮</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    threeItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checkList: [],
      checkListErr: [],
      form: ""
    };
  },
  methods: {
    selectChange(a, val) {
      console.log(this.threeItem);
      const i = this.checkList.findIndex(item => item === val);
      if (i == -1) {
        this.checkList.push(val);
      } else {
        this.checkList = this.checkList.filter(obj => obj !== val);
      }
      this.threeItem.list.forEach(res => {
        res.checkListErr = this.checkList;
      });
    },
    checkboxChange(a, val) {
      const i = this.checkListErr.findIndex(item => item === val);
      if (i == -1) {
        this.checkListErr.push(val);
      } else {
        this.checkListErr = this.checkListErr.filter(obj => obj !== val);
      }
      this.threeItem.list.forEach(res => {
        res.checkListErr2 = this.checkListErr;
      });
    },
    //隐藏表头
    handerMethod({ row, columnIndex }) {
      if (row[2].level == 1) {
        //这里有个非常坑的bug 必须是row[0]=0 row[1]=2才会生效
        row[1].colSpan = 1;
        row[3].colSpan = 2;
        row[2].colSpan = 2;
        if (columnIndex === 3) {
          return { display: "none" };
        }
      }
    },
    objectSpanMethod({ column, rowIndex }) {
      let columnsLabel2 = ["使用图卡"];
      if (columnsLabel2.includes(column.label)) {
        //  合并对应列的第一行
        if (rowIndex === 0) {
          return [5, 1];
        } else if (rowIndex === 5) {
          return [8, 1];
        } else {
          //  隐藏对应列的剩余行
          return [0, 0];
        }
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.topicBox {
  font-size: 20px;
  margin: 50px auto;
}
.topicBox {
  .topicBox_big {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .topicBox_1 {
    display: flex;
  }
}

::v-deep .el-table__empty-block {
  display: none;
}
.elTableTop {
  width: 1800px;
}
::v-deep.tableBottom {
  width: 1800px;
  border: none !important;
  // border: 1px solid black;
  .el-table_2_column_16 {
    // border-right: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
  }
  .cell {
    padding: 0 !important;
  }
  // .el-table_2_column_17 {
  //   border-right: 1px solid #ebeef5;
  // }
}
::v-deep.el-table thead.is-group th.el-table__cell {
  background: #ffffff !important;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(0, 0, 0, 0) !important;
}

.tone {
  ::v-deep .el-input .el-input__inner,
  .el-input.is-disabled .el-input__inner {
    background-color: transparent;
    border: none;
    font-size: 20px;
  }
}
.elHeader {
  border-bottom: 1px solid #ebeef5;
}
::v-deep .el-input .el-input__inner,
.el-input.is-disabled .el-input__inner {
  background-color: transparent;
  border: none;
  font-size: 20px;
}
.box1 {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 2;
  margin-bottom: 10px;
}

.headerErr {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: center;
}
.el-form-item {
  margin-bottom: 0;
}

.form {
  width: 150px;
  border-bottom: 1px solid black;
}
</style>